import { useMemo } from 'react'

import { useUser } from '@/client/context/user'

import { PlatformRuntime, type WebPushNotificationsInterface } from './constants'
import * as ios from './ios'
import * as web from './web'

export default function usePushNotifications(): WebPushNotificationsInterface {
  const noOpValue = useMemo(
    () => ({
      isSupported: false,
      isEnabled: false,
      async toggleSubscription() {
        // No op
      },
      element: null,
    }),
    []
  )

  const userContext = useUser()

  if (userContext.platformRuntime === PlatformRuntime.ios) {
    return ios.usePushNotifications()
  }

  if (userContext.platformRuntime === PlatformRuntime.web) {
    return web.usePushNotifications()
  }

  return noOpValue
}
